/**
 * Barrel export for UI Shell-komponenter
 *
 * Eksporterer alle egne React UI Shell-komponenter for enkel import:
 *   import { Header, SideNav, Switcher } from '@/components/ui-shell';
 */

export { default as Header } from './Header';
export { default as HeaderMenuButton } from './HeaderMenuButton';
export { default as HeaderName } from './HeaderName';
export { default as HeaderNav } from './HeaderNav';
export { default as HeaderNavItem } from './HeaderNavItem';
export { default as HeaderGlobalAction } from './HeaderGlobalAction';
export { default as HeaderPanel } from './HeaderPanel';
export { default as SideNav } from './SideNav';
export { default as SideNavLink } from './SideNavLink';
export { default as SideNavMenu } from './SideNavMenu';
export { default as SideNavMenuItem } from './SideNavMenuItem';
export { default as SideNavDivider } from './SideNavDivider';
export { default as Switcher } from './Switcher';
export { default as SwitcherItem } from './SwitcherItem';
export { default as SwitcherDivider } from './SwitcherDivider';
